exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pollTable td{min-width:60px}.pollsList .pollMembers tr td .smallEntry label{line-height:25px;height:25px}", "", {"version":3,"sources":["C:/Users/fpluq/Projects/groopus-vue/src/components/Polls/Poll.vue"],"names":[],"mappings":"AACA,cACE,cAAgB,CACjB,AACD,gDACE,iBAAkB,AAClB,WAAa,CACd","file":"Poll.vue","sourcesContent":["\n.pollTable td {\n  min-width: 60px;\n}\n.pollsList .pollMembers tr td .smallEntry label {\n  line-height: 25px;\n  height: 25px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70e31bb7","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Polls/Poll.vue
// module id = 972
// module chunks = 1 7